// extracted by mini-css-extract-plugin
module.exports = {"checkoutPrimaryButton":"ON","shipOptionItem":"PN","legend":"QN","primaryHeading":"RN"};